import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "venueWideRadio",
    "specificTableRadio",
    "tableSelect",
    "oneTimeRadio",
    "oneTimeFields",
    "weeklyRadio",
    "weeklyFields",
    "annualRadio",
    "annualFields",
    "allDayCheckbox",
    "timeFields"
  ]

  scopeChanged(event) {
    const isSpecific = this.specificTableRadioTarget.checked

    if (isSpecific) {
      this.tableSelectTarget.style.display = "block"
    } else {
      this.tableSelectTarget.style.display = "none"
      // Clear table selection when switching to venue-wide
      const select = this.tableSelectTarget.querySelector("select")
      if (select) select.value = ""
    }
  }

  blockTypeChanged(event) {
    // Hide all type-specific fields first
    this.oneTimeFieldsTarget.style.display = "none"
    this.weeklyFieldsTarget.style.display = "none"
    this.annualFieldsTarget.style.display = "none"

    // Show the appropriate fields based on selection
    if (this.oneTimeRadioTarget.checked) {
      this.oneTimeFieldsTarget.style.display = "grid"
    } else if (this.weeklyRadioTarget.checked) {
      this.weeklyFieldsTarget.style.display = "block"
    } else if (this.annualRadioTarget.checked) {
      this.annualFieldsTarget.style.display = "grid"
    }
  }

  allDayChanged(event) {
    const isAllDay = this.allDayCheckboxTarget.checked

    if (isAllDay) {
      this.timeFieldsTarget.style.display = "none"
    } else {
      this.timeFieldsTarget.style.display = "grid"
    }
  }
}
